import React from "react";
import { DatePicker } from "antd";
import { Field, ErrorMessage } from "formik";
import dayjs from "dayjs";
import TextError from "./TextError";

function toValidDayjs(value) {
  if (!value) return null;
  if (dayjs.isDayjs(value)) return value.isValid() ? value : null;
  const d = dayjs(value);
  return d.isValid() ? d : null;
}

function DatePickerField(props) {
  const { label, name, ...rest } = props;
  return (
    <div className="mb-1">
      <div className="mb-1">
        <label htmlFor={name}>{label}</label>
      </div>
      <Field name={name}>
        {({ form, field }) => {
          const hasError = form.touched[name] && form.errors[name];
          return (
            <DatePicker
              id={name}
              {...rest}
              value={toValidDayjs(field.value)}
              onChange={(date) => form.setFieldValue(name, date ? date.toISOString() : "")}
              onBlur={() => form.setFieldTouched(name, true)}
              status={hasError ? "error" : ""}
              style={{ width: "100%" }}
            />
          );
        }}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
}

export default DatePickerField;
